import WIDGETS from './widgets';

export default {
	name: 'broadcast_message',
	spacing: 2,
	widgets: [{ content: WIDGETS.BROADCAST_MESSAGE_LIST, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
